import {Component, inject, OnInit} from '@angular/core';
import {DialogButtonComponent} from '../../../../../../shared/common/dialog-button/dialog-button.component';
import {Divider} from 'primeng/divider';
import {LoadingComponent} from '../../../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../../../components/generic/message/message.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {RestErrorHelper} from '../../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../../service/player-profile.service';
import {ErrorType} from '../../../../../../../model/error-type';
import {PlayerProfile} from '../../../../../model/player-profile';
import {DialogHelper} from '../../../../../../shared/helper/dialog-helper';
import {InfoTextComponent} from '../../../../../../shared/common/info-text/info-text.component';
import {Button} from 'primeng/button';
import {Router} from '@angular/router';
import {environment} from '../../../../../../../../environments/environment';
import {TeamsLeaguesResponse} from '../../../../../model/api/teams-leagues-response';
import {TeamLeague} from '../../../../../model/api/team-league';
import {Select} from 'primeng/select';
import {NgTemplateOutlet} from '@angular/common';
import {SwitchComponent} from '../../../../../../shared/common/switch/switch.component';
import {
  PlayerProfileProFeatureComponent
} from '../../../../player-profile-register/player-profile-pro-feature/player-profile-pro-feature.component';

@Component({
  selector: 'app-player-profile-add-league-dialog',
  imports: [
    DialogButtonComponent,
    Divider,
    LoadingComponent,
    MessageComponent,
    ReactiveFormsModule,
    TranslatePipe,
    InfoTextComponent,
    Button,
    Select,
    FormsModule,
    NgTemplateOutlet,
    SwitchComponent,
    PlayerProfileProFeatureComponent
  ],
  templateUrl: './player-profile-add-league-dialog.component.html',
  styleUrl: './player-profile-add-league-dialog.component.scss'
})
export class PlayerProfileAddLeagueDialogComponent implements OnInit
{
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);
  private router = inject(Router);
  private translate = inject(TranslateService);

  isLoading: boolean;
  isSaving: boolean;
  errorMsg: ErrorType;
  customError: string;
  playerProfile: PlayerProfile;
  isPro: boolean;

  teamsLeaguesResponse: TeamsLeaguesResponse;
  selectedTeamLeague: TeamLeague;
  calendarSync: boolean;

  public static openDialog(dialogService: DialogService, playerProfile: PlayerProfile, translate: TranslateService): DynamicDialogRef
  {
    return dialogService.open(
      PlayerProfileAddLeagueDialogComponent,
      DialogHelper.createBasicConfig({
        header: translate.instant('ADD_LEAGUE'),
        width: DialogHelper.getDialogWidth(700),
        data: {playerProfile}
      }));
  }

  constructor()
  {
    this.playerProfile = this.config.data.playerProfile;
  }

  ngOnInit(): void
  {
    this.isPro = this.playerProfileService.playerAuthenticationService.isProVersion();
    this.calendarSync = this.isPro;

    this.leadLeagues();
  }

  public gotoAccountLinks(): void
  {
    this.ref.close(false);
    this.router.navigate([environment.frontendPrefix + '/player/profile/account/links']).then(() => {});
  }

  private leadLeagues(): void
  {
    if (this.isLoading)
      return;

    this.isLoading = true;
    this.errorMsg = undefined;
    this.customError = '';

    this.playerProfileService.getPossiblePlayerLeagueTeams().subscribe({
      next: data =>
      {
        console.log('Mögliche Ligen erhalten', data);
        this.teamsLeaguesResponse = data;
        if (this.teamsLeaguesResponse?.teamLeagues?.length === 1)
          this.selectedTeamLeague = this.teamsLeaguesResponse.teamLeagues[0];
        this.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isLoading = false;
        if (error.error?.message === 'PLAYER_PROFILE_TEAMS_NO_LINKED_PLAYERS_MSG')
          this.customError = 'PLAYER_PROFILE_TEAMS_NO_LINKED_PLAYERS_MSG';
        else this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  onOkClicked(): void
  {
    if (!this.selectedTeamLeague)
      return;

    this.isSaving = true;
    this.selectedTeamLeague.calendarSync = this.calendarSync;

    this.playerProfileService.linkPlayerTeamLeague(this.selectedTeamLeague).subscribe({
      next: () => this.ref.close(true),
      error: error =>
      {
        this.isSaving = false;
        this.restErrorHelper.handleErrorService(error);
      }
    });
  }

  onCancelClicked(): void
  {
    if (!this.isSaving)
      this.ref.close(false);
  }
}
